import StringParser from '../StringParser';

/* global window */

class General {
	static getPageTitle(pathName, orgName = '') {
		let title = '';

		if (pathName.startsWith('/gallery')) {
			title = 'Galeria';
		}

		return `${StringParser.capitalize(orgName)}${title ? ` - ${title}` : ''}`;
	}

	static getCurrentLocation() {
		return window.location.hostname;
	}

	static getWebName(domain) {
		const roverpixWebNames = ['127.0.0.1', '0.0.0.0', 'localhost'];

		if (roverpixWebNames.includes(domain)) {
			return 'fotos';
		}

		if (domain.endsWith('.roverpix.com')) {
			return domain.slice(0, -'.roverpix.com'.length);
		}

		// Custom client domains (e.g. ccxp.photopark.com.br → ccxp)
		if (domain.endsWith('.photopark.com.br')) {
			return domain.split('.')[0];
		}

		// CCXP's own domains (e.g. fotoseautografos.ccxp.com.br) are all the ccxp organization
		if (domain === 'ccxp.com.br' || domain.endsWith('.ccxp.com.br')) {
			return 'ccxp';
		}

		return domain.split('.')[0];
	}

	// A ticket or credential as typed, often on a phone: trimmed, then lowercase as a
	// second try (phone keyboards capitalize the first letter; tickets are stored lowercase)
	static credentialCandidates(text) {
		const trimmed = String(text || '').trim();
		if (!trimmed) return [];
		const lower = trimmed.toLowerCase();
		return lower === trimmed ? [trimmed] : [trimmed, lower];
	}

	// The cards of the first form of the credential the API knows: { credential, cards }, or null
	static async findCredentialCards(text) {
		const candidates = General.credentialCandidates(text);
		for (let i = 0; i < candidates.length; i++) {
			const candidate = candidates[i];
			const url = `${process.env.ROVERPIX_API}/api/v1/card/customer/external_id/${encodeURIComponent(candidate)}`;
			let response = null;
			try {
				const res = await fetch(url, { method: 'GET' });
				response = res.ok ? await res.json() : null;
			} catch (e) {
				// A network error, an error page the browser can't read (no CORS) or not JSON:
				// that form of the credential found nothing
				response = null;
			}
			if (response && Array.isArray(response.cards) && response.cards.length > 0) {
				return { credential: candidate, cards: response.cards };
			}
		}
		return null;
	}

	static getWebNameFromCurrentLocation() {
		const currentLocation = General.getCurrentLocation();

		return General.getWebName(currentLocation);
	}

	static downloadURI(uri) {
		const link = document.createElement("a");
		link.href = uri;
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	}
}

export default General;
